var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010101;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.417,0,0,.417,0,0)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.7,23.7c0,13.1-10.6,23.7-23.7,23.7s-23.7-10.6-23.7-23.7S236.9,0,250,0S273.7,10.6,273.7,23.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400.4,23.7c0,13.1-10.6,23.7-23.7,23.7s-23.7-10.6-23.7-23.7S363.5,0,376.7,0S400.4,10.6,400.4,23.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.1,23.7c0,13.1-10.6,23.7-23.7,23.7S99.6,36.9,99.6,23.7S110.2,0,123.3,0S147.1,10.6,147.1,23.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.5,500V223.3l115,115l37.5-37.5L268.8,140.5c-5-5-11.7-7.8-18.8-7.8c-7,0-13.8,2.8-18.8,7.8L71,300.7 l37.5,37.5l115-115V500H276.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.3414faf3bb5a486d457d8655c99104d3.svg";
export { ForwardRef as ReactComponent };